import { h, Fragment } from "preact";
import { useState, useEffect } from "preact/hooks";
import {
	Box,
	Button,
	Checkbox,
	DialogActions,
	DialogContent,
	Dialog,
	DialogTitle,
	FormControlLabel,
	IconButton,
	Stack,
	Switch,
	Tooltip,
	Typography,
	List,
	ListItem,
	ListItemAvatar,
	ListItemText,
	ListItemSecondaryAction,
	TextField,
} from "@mui/material";
import { DropzoneArea } from "material-ui-dropzone";

import ThumbDownIcon from "@mui/icons-material/ThumbDown";
import ThumbUpIcon from "@mui/icons-material/ThumbUp";

import CloseIcon from "@mui/icons-material/Close";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import palette from "../../theme/palette";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import PostAddIcon from "@mui/icons-material/PostAdd";
import DownloadFile from "../Common/DownloadFile";

export default function NotaryProbingDialog(props) {
	console.log("NotaryProbingDialog", props);
	//if (props.state.docs === undefined) return;

	const [state, setState] = useState({ mode: "P", inm: props.state.params.docs.inm });
	const handleChange = (event) => {
		setState({ ...state, [event.target.name]: event.target.value });
	};
	const handleClose = () => {

		setState({ mode: undefined })

	};
	const handleChangeCheckbox = (event) => {
		setState({ ...state, [event.target.name]: event.target.checked });
		const requestOptions = {
			method: "POST",
			headers: { "Content-Type": "application/json" },
			body: JSON.stringify({ inm: event.target.checked }),
		};
		fetch("/api/7e3207e354564cfd82cb33944bae696a/" + props.state.params.docs.u, requestOptions)
			.then((response) => {
				return response.json();
			})
			.then((res) => {
				switch (res.res) {
					case "ok":
						//window.location.reload();
						props.state.params.dataRoomUpdate();
						props.onClose();

						break;

					case "err":
						break;
					default:
						break;
				}
			});
	};
	const handleFlipComplete = () => {
		const requestOptions = {

			headers: { "Content-Type": "application/json" },

		};
		fetch("/api/e821cf7df9be4c7dba66c2f2eb7e5190/" + props.state.params.docs.u + "/" + props.state.params.docs.ic, requestOptions)
			.then((response) => {
				return response.json();
			})
			.then((res) => {
				switch (res.res) {
					case "ok":
						props.state.params.dataRoomUpdate();
						props.onClose();
						break;

					case "err":
						break;
					default:
						break;
				}
			});
	};
	const handleDocOK = (doc_uid) => {
		const requestOptions = {
			method: "POST",
			headers: { "Content-Type": "application/json" },
			body: JSON.stringify({ uid: doc_uid }),
		};
		fetch("/api/57704ff295a0494180dc7f0eb5b183c5", requestOptions)
			.then((response) => {
				return response.json();
			})
			.then((res) => {
				switch (res.res) {
					case "ok":
						props.state.params.dataRoomUpdate();
						//props.onClose();
						break;

					case "err":
						break;
					default:
						break;
				}
			});
	};
	const handleDocNOK = (doc_uid) => {
		const requestOptions = {
			method: "POST",
			headers: { "Content-Type": "application/json" },
			body: JSON.stringify({ uid: doc_uid, comment: state.comment }),
		};
		fetch("/api/bfaa63ddc00d46bb874a6f279a99930e", requestOptions)
			.then((response) => {
				return response.json();
			})
			.then((res) => {
				switch (res.res) {
					case "ok":
						props.state.params.dataRoomUpdate();

						break;

					case "err":
						break;
					default:
						break;
				}
			});
	};

	const handleSendMessage = () => {
		const requestOptions = {
			method: "POST",
			headers: { "Content-Type": "application/json" },
			body: JSON.stringify(state),
		};
		fetch("/api/308a17e15c6c432681daefe51af4cddb/" + props.dps, requestOptions)
			.then((response) => {
				return response.json();
			})
			.then((res) => {
				switch (res.res) {
					case "ok":
						window.location.reload();
						break;

					case "err":
						break;
					default:
						break;
				}
			});
	};

	const [files, setFiles] = useState([]);
	const handleChangeFiles = (files) => {

		setFiles(files);
	};

	useEffect(() => {
		if (state.mode === undefined) {
			console.log("useeffect close")
			props.onClose();
		}

	}, [state.mode])

	return (
		<Dialog onClose={handleClose} aria-labelledby="add-user-dialog" open={props.state.opened} maxWidth="xl" fullWidth={false}>
			<DialogTitle id="add-user-dialog">
				<Stack flexDirection={"row"} justifyContent={"space-between"} alignItems={"center"}>
					<Typography variant="h5"><em>{props.state.params.title}</em> </Typography>
					<FormControlLabel checked={props.state.params.docs.ic}
						onChange={handleFlipComplete} control={<Switch />} label="Complet" />
				</Stack>
			</DialogTitle>
			<DialogContent dividers>
				<Stack spacing={1}>
					{state.mode === "P" && (
						<Stack spacing={1} direction="row" justifyContent="space-between" alignItems="center">
							<FormControlLabel
								control={
									<Checkbox
										checked={props.state.params.docs.inm}
										onChange={handleChangeCheckbox}
										name="inm"
										color="primary"
									/>
								}
								label="Cette catégorie n'est pas nécessaire"
							/>
							{/* <Tooltip title="Ajouter un document"
							>
								<CloudUploadIcon
									color="primary"
								/>
							</Tooltip> */}
						</Stack>
					)}
					{state.mode === "U" && (
						<DropzoneArea
							onChange={handleChangeFiles}
							acceptedFiles={["image/jpeg", "image/png", "image/tiff", "application/pdf"]}
							maxFileSize={50000000}
							dropzoneText={<Typography variant="h5">Cliquez ici ou glissez-déplacez vos fichiers ici</Typography>}
							getFileAddedMessage={(fileName) => `Fichier ${fileName} ajouté :)`}
							getFileRemovedMessage={(fileName) => `Le fichier ${fileName} a bien été enlevé :)`}
							getFileLimitExceedMessage={(nbFiles) => `Vous ne pouvez pas ajouter plus de ${nbFiles} documents à la fois`}
							showAlerts={["error"]}
							Icon={PostAddIcon}
						/>
					)}
					{state.mode === "P" && (
						<List style="min-width: 400px;">
							{props.state && props.state.params && props.state.params.docs &&
								props.state.params.docs.r &&
								props.state.params.docs.r.map((f) => (
									<ListItem key={f.u} style="padding-left: 0px">
										{f.t && <ListItemAvatar>
											<img src={`${THUMBS_URL}/${f.st}-100.jpg`} height={100} width={100} style="border: lightgray 1px solid; border-radius: 10px;" />
										</ListItemAvatar>}

										<ListItemText
											primary={
												<Typography variant="h5" gutterBottom sx={{ paddingLeft: "10px" }}>
													Document {f.i}
												</Typography>
											}
											secondary={f.dt}
											style={"margin-left: 10px; margin-right: 10px"}
										/>
										<ListItemSecondaryAction>
											<Stack spacing={1} direction="row" justifyContent="space-between" alignItems="center">
												{f.sts === 1 && (
													<CheckCircleOutlineIcon
														style={{
															color: palette.success.main,
														}}
													/>
												)}
												{f.sts === 2 && <CloseIcon color="primary" />}

												<DownloadFile f={f} mode="docs" tooltip={"Télécharger le document"} />

												{f.sts === 0 && (
													<Fragment>
														<Tooltip title="Accepter le document">
															<IconButton edge="end" aria-label="grant" onClick={() => handleDocOK(f.u)}>
																<ThumbUpIcon />
															</IconButton>
														</Tooltip>
														<Tooltip title="Rejeter le document">
															<IconButton
																edge="end"
																aria-label="reject"
																onClick={() => setState({ ...state, step1: true, uid: f.u })}
															>
																<ThumbDownIcon />
															</IconButton>
														</Tooltip>
													</Fragment>
												)}
											</Stack>
										</ListItemSecondaryAction>
									</ListItem>
								))}
						</List>
					)}
					{state.step1 === true && (
						<Stack>
							<TextField
								id="comment"
								name="comment"
								variant="outlined"
								style={{
									marginLeft: 0,
									marginRight: 10,
								}}
								placeholder="Commentaire"
								fullWidth
								multiline
								rows={5}
								margin="dense"
								value={state.comment}
								onChange={handleChange}
							/>
							<Button variant="contained" onClick={() => handleDocNOK(state.uid)}>
								Rejeter
							</Button>
						</Stack>
					)}
					{state.mode === "M" && (
						<Stack spacing={1}>
							<Stack spacing={1} direction="row" justifyContent="space-between" alignItems="center">
								<Typography variant="body1">Modèles</Typography>
								<Button
									onClick={() =>
										setState({
											...state,
											subject: `${props.state.params.header} | Un document manque pour la catégorie "${props.state.params.title}"`,
											content: `Bonjour, \nUn ou plusieurs documents manquent dans la catégorie "${props.state.params.title}"`,
										})
									}
								>
									Document manquant
								</Button>
								<Button
									onClick={() =>
										setState({
											...state,
											subject: `${props.state.params.header} | Un document est incomplet pour la catégorie "${props.state.params.title}"`,
											content: `Bonjour, \nUn ou plusieur documents sont incomplets`,
										})
									}
								>
									Document incomplet
								</Button>
							</Stack>
							<Typography variant="body1">Message envoyé au vendeur référent {props.state.params.dps_name}</Typography>
							<TextField
								id="subject"
								name="subject"
								variant="outlined"
								style={{
									marginLeft: 0,
									marginRight: 10,
								}}
								placeholder="Sujet"
								fullWidth
								size="small"
								margin="dense"
								value={state.subject || props.state.params.header || ""}
								onChange={handleChange}
							/>
							<TextField
								id="content"
								name="content"
								variant="outlined"
								style={{
									marginLeft: 0,
									marginRight: 10,
								}}
								placeholder="Contenu"
								fullWidth
								multiline
								rows={5}
								margin="dense"
								value={state.content}
								onChange={handleChange}
							/>
						</Stack>
					)}
				</Stack>
			</DialogContent>
			<DialogActions>
				<Box display="flex" justifyContent="space-between" style="width: 100%">
					<Box>
						{state.mode === "P" && <Button onClick={handleClose}>Fermer</Button>}
						{["M", "U"].includes(state.mode) && (
							<Button
								onClick={() => {
									setState({ ...state, mode: "P" });
								}}
							>
								Annuler
							</Button>
						)}
					</Box>
					<Box>

						{state.mode === "U" && (
							<Button onClick={props.yes_action} variant="contained" disabled={files.length === 0}>
								Envoyer le{files.length > 1 ? "s" : ""} fichier{files.length > 1 ? "s" : ""}
							</Button>
						)}
						{state.mode === "M" && (
							<Button
								onClick={
									handleSendMessage
								}
								variant="contained"
								disabled={state.subject === undefined || state.content === undefined}
							>
								Envoyer le message
							</Button>
						)}
					</Box>
				</Box>
			</DialogActions>
		</Dialog>
	);
}
